import { all, put, takeLatest } from 'redux-saga/effects';

import { types as trainingsPageLoaded } from '../ducks/trainingPageLoaded';

export function * watchTrainingPageLoaded() {
    yield takeLatest(trainingsPageLoaded.TRAININGPAGELOADED_GET, onTrainingsPageLoadedGet);
    yield takeLatest(trainingsPageLoaded.TRAININGPAGELOADED_SUCCESS, onTrainingsPageLoadedGetResponse);
}

export function * onTrainingsPageLoadedGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onTrainingsPageLoadedGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'TRAININGPAGELOADED') {
        return yield all([
            put({
                type: trainingsPageLoaded.TRAININGPAGELOADED_SET,
                payload: response,
            }),
        ]);
    }
}
